"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventLoopSpinner = exports.EventLoopSpinner = void 0;
const event_loop_spinner_1 = require("./event-loop-spinner");
Object.defineProperty(exports, "EventLoopSpinner", { enumerable: true, get: function () { return event_loop_spinner_1.EventLoopSpinner; } });
exports.eventLoopSpinner = new event_loop_spinner_1.EventLoopSpinner();
//# sourceMappingURL=index.js.map